import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Logo } from '../Logo';
import { H1, Text } from '../Typography';

export const OnboardingContent = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space['3xl'])};
  justify-items: center;
  width: 100%;
  max-width: ${toRem(620)};
  height: auto;
  padding: ${toRem(theme.space['3xl'])};
  overflow: hidden;
  text-align: center;

  > img {
    width: 100%;
    max-width: ${toRem(350)};
  }
`;

const ContentHeaderLayout = styled.header`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
  text-align: center;
`;

const HeaderTitle = styled(H1)`
  margin-top: ${toRem(theme.space.xl)};
  margin-bottom: 0;
`;

const HeaderMessage = styled(Text).attrs({
  size: 'default',
})`
  margin-top: ${toRem(theme.space.md)};
`;

interface ContentHeaderProps {
  title?: string;
  message?: string | React.ReactNode;
  logoVisible?: boolean;
  className?: string;
}

export const OnboardingHeader: React.FC<ContentHeaderProps> = ({ logoVisible = false, title, message, className, ...rest }) => (
  <ContentHeaderLayout className={className} {...rest}>
    {logoVisible && <Logo />}
    <HeaderTitle data-cy="title">{title}</HeaderTitle>
    {message && <HeaderMessage data-cy="subtitle">{message}</HeaderMessage>}
  </ContentHeaderLayout>
);

export const OnboardingFooter = styled.footer`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.xl)};
  justify-items: center;
  width: 100%;
  height: auto;
  padding: ${toRem(theme.space['3xl'])} 0 0;
  border-top: ${toRem(1)} solid ${theme.color.neutral[200]};

  > * {
    width: fit-content;
  }
`;
